import { render, staticRenderFns } from "./competitive_collection.vue?vue&type=template&id=56ec4a76&scoped=true"
import script from "./competitive_collection.vue?vue&type=script&lang=js"
export * from "./competitive_collection.vue?vue&type=script&lang=js"
import style0 from "./competitive_collection.vue?vue&type=style&index=0&id=56ec4a76&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec4a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ec4a76')) {
      api.createRecord('56ec4a76', component.options)
    } else {
      api.reload('56ec4a76', component.options)
    }
    module.hot.accept("./competitive_collection.vue?vue&type=template&id=56ec4a76&scoped=true", function () {
      api.rerender('56ec4a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/visitDetail/components/competitive_collection.vue"
export default component.exports